import type { ReactNode } from 'react';

type Props = {
  children: ReactNode;
  className?: string;
};

export function Card({ children, className }: Props) {
  return <div className={'card' + (className ? ' ' + className : '')}>{children}</div>;
}

export function CardHead({
  title, desc, right,
}: { title: ReactNode; desc?: ReactNode; right?: ReactNode }) {
  return (
    <div className="block-head">
      <div>
        <div className="block-title">{title}</div>
        {desc && <div className="block-desc">{desc}</div>}
      </div>
      {right && <div className="block-right">{right}</div>}
    </div>
  );
}
